import { _ } from "../../../polyglot/polyglot.js";
import { notBlank } from "../../../widgets/forms/validators.js";
import AbstractFormStep from "../../AbstractFormStep.js";
import button from "@foretagsplatsen/finsit-design-system/widget-js/elements/button";
import RadioGroupWidget from "../../../widgets/RadioGroupWidget/RadioGroupWidget.js";

/**
 * The step to choose various import options for E-conomic.
 */
export default class ImportOptionsSelectionStep extends AbstractFormStep {
	constructor({ redirectToEconomic }) {
		super(...arguments);
		this._canGoToPreviousStep = false;
		this._redirectoEconomic = redirectToEconomic;
	}

	_populateForm(form) {
		const elements = [
			{
				name: "partialData",
				label: _("Import only new data"),
				selected: true,
				dataTestName: "import-new-data",
				value: true,
			},
			{
				name: "allData",
				label: _("Import all data (replaces existing data)"),
				selected: false,
				dataTestName: "import-all-data",
				value: false,
			},
		];

		form.input({
			label: _("Agreement number"),
			name: "agreementNumber",
			attribute: "economicAgreementNumber",
			value: this._context.economicAgreementNumber,
			validator: notBlank(),
			disabled: true,
		});

		form.input({
			label: _("Agreement Grant Token"),
			name: "economicToken",
			attribute: "economicToken",
			value: this._context.economicToken,
			placeHolder:
				this._context.company.hasEconomicIntegrationWithAccessGrantToken()
					? _("Use existing access token")
					: "",
		});

		form.addRenderable({
			label: _("Token management"),
			content: button(
				{
					primary: true,
					onClick: () => this._redirectoEconomic(),
				},
				_("Get new E-conomic credentials"),
			),
			accessor: () => {},
			getFormValue: () => {},
			setFormValue: () => {},
		});

		this._radioGroup = new RadioGroupWidget({ elements });

		form.addRenderable({
			label: _("Load data"),
			content: this._radioGroup,
			accessor: () => {},
			getFormValue: () => {
				this._context.partialImport = this._radioGroup.getValue();
			},
			setFormValue: () => {},
		});

		form.switchButton({
			name: "import-draft-vouchers",
			attribute: "importDraftVouchers",
			label: _("Import draft vouchers"),
		});
	}
}
